const FXDashboard = () => {
    return(
        <div >FX Dashboard Summary Works! </div>
    )
    }
    
    export default FXDashboard